// notificationsApi.ts
import axios from 'axios';
import apiConfig from '../../pages/apiConfig.ts';
import { NotificationItem, NotificationsResponse } from './types';

const API_BASE_URL = apiConfig.apiBaseURL;

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

export const notificationsApi = {
  // Get all notifications
  getNotifications: async (): Promise<NotificationsResponse> => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/notifications`,
        {
          headers: getAuthHeaders()
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error fetching notifications:', error);
      return {
        status: 'Failed',
        message: error.response?.data?.message || 'Failed to fetch notifications',
        data: {
          notifications: [],
          unreadCount: 0,
          totalCount: 0
        }
      };
    }
  },

  // Get unread count
  getUnreadCount: async (): Promise<{ status: string; unreadCount: number }> => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/notifications/unread-count`,
        {
          headers: getAuthHeaders()
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error fetching unread count:', error);
      return {
        status: 'Failed',
        unreadCount: 0
      };
    }
  },

  // Mark notification as read
  markAsRead: async (notificationId: string): Promise<{ status: string; message: string }> => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/notifications/${notificationId}/read`,
        {},
        {
          headers: getAuthHeaders()
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error marking notification as read:', error);
      return {
        status: 'Failed',
        message: error.response?.data?.message || 'Failed to mark notification as read'
      };
    }
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<{ status: string; message: string }> => {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/notifications/mark-all-read`,
        {},
        {
          headers: getAuthHeaders()
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error marking all notifications as read:', error);
      return {
        status: 'Failed',
        message: error.response?.data?.message || 'Failed to mark all notifications as read'
      };
    }
  },

  // Delete notification
  deleteNotification: async (notificationId: string): Promise<{ status: string; message: string }> => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/notifications/${notificationId}`,
        {
          headers: getAuthHeaders()
        }
      );

      return response.data;
    } catch (error: any) {
      console.error('Error deleting notification:', error);
      return {
        status: 'Failed',
        message: error.response?.data?.message || 'Failed to delete notification'
      };
    }
  },
};